import { TypePageSection } from '../../@types/generated';

export function isObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

export default function getSettingsFromSection(section: TypePageSection) {
  return isObject(section.fields.settings) ? section.fields.settings : {};
}
